import React, { createContext, useContext, useEffect, useMemo } from "react";
import { AuthContext } from "./AuthContext";
import { FetchContext } from "./FetchContext";
import {
  configureSessionEvents,
  startSessionEvents,
  stopSessionEvents,
  trackSessionEvent,
} from "../analytics/sessionEvents";

const SessionEventsContext = createContext({
  trackEvent: (_name) => {},
});

const SessionEventsProvider = ({ children }) => {
  const authContext = useContext(AuthContext);
  const fetchContext = useContext(FetchContext);

  useEffect(() => {
    configureSessionEvents({
      axios: fetchContext?.authAxios,
      getToken: () => authContext.getToken(),
      flushIntervalMs: 30_000,
    });
  }, [fetchContext?.authAxios, authContext]);

  useEffect(() => {
    const isAuthenticated = authContext.isUserAuthenticated();
    if (isAuthenticated) {
      startSessionEvents();
    } else {
      stopSessionEvents({ clearPending: true });
    }
    return () => stopSessionEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authContext.authState]);

  const value = useMemo(() => ({ trackEvent: trackSessionEvent }), []);

  return <SessionEventsContext.Provider value={value}>{children}</SessionEventsContext.Provider>;
};

export { SessionEventsContext, SessionEventsProvider };

